<template>
  <div class="card-modern">
  
    <!-- HEADER + FILTER + BUTTON -->
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap">
      <div>
        <h2 class="card-title-modern">
          Monitoring Perjanjian Kerja Sama
        </h2>
        <p class="card-desc-modern mb-0">
          Kelola dokumen perjanjian kerja sama.
        </p>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div class="position-relative" style="width:170px">
        <i class="bi bi-search text-muted"
          style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1;"></i>
        <input v-model="filters.search" class="form-control" placeholder="Cari"
          style="padding-left: 32px; border-radius: 8px;" @input="onSearchInput" />
      </div>
      <select v-model="filters.division" class="form-select" style="width: 180px;" @change="applyFilters">
        <option value="">Semua Department</option>
        <option v-for="div in divisionList" :key="div.mst_division_id" :value="div.mst_division_id">{{
          div.mst_division_name }}</option>
      </select>
      <select v-model="filters.description_id" class="form-select" style="width: 180px;" @change="applyFilters">
        <option value="">Semua Keterangan</option>
        <option v-for="desc in descriptionList" :key="desc.value" :value="desc.value">{{
          desc.description }}</option>
      </select>
  
      <!-- Status: sama dengan badge di kolom Status -->
      <select v-model="filters.expired_status" class="form-select" style="width: 160px;" @change="applyFilters">
        <option value="">Semua Status</option>
        <option value="ACTIVE">Active</option>
        <option value="SOON EXPIRED">Soon Expired</option>
        <option value="EXPIRED">Expired</option>
        <option value="SUPERSEDED">Superseded</option>
        <option value="INACTIVE">Inactive</option>
      </select>
  
      <!-- Filter file: sudah / belum ada file kontrak -->
      <select v-model="filters.has_file" class="form-select" style="width: 160px;" @change="applyFilters">
        <option value="">Semua File</option>
        <option value="1">Sudah ada file</option>
        <option value="0">Belum ada file</option>
      </select>
      <button class="button-modern" @click="goToAdd">+ Add Dokumen</button>
    </div>
  
    <!-- TABLE -->
    <div class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr width="220">
            <th class="text-center"></th>
            <th>Nama Perusahaan</th>
            <th>Nomor Dokumen</th>
            <th>Keterangan</th>
            <th>Progress</th>
            <th>Renewal</th>
            <!-- <th>Status</th> -->
            <th>Status</th>
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
  
          <!-- LOADING -->
          <tr v-if="loading">
            <td colspan="8" class="text-center py-4">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Memuat data...
            </td>
          </tr>
  
          <!-- EMPTY -->
          <tr v-else-if="documents.length === 0">
            <td colspan="8" class="text-center py-4 text-muted">
              Tidak ada data dokumen
            </td>
          </tr>
  
          <!-- DATA -->
  
          <tr v-else v-for="item in documents" :key="item.document_id">
            <td class="text-center">
              <span class="file-dot" :class="item.file_path ? 'file-dot--yes' : 'file-dot--no'"
                :title="item.file_path ? 'Ada file' : 'Belum upload file'"></span>
            </td>
  
            <td>{{ item.mst_corporate_name }}</td>
  
            <!-- Nomor dokumen -->
            <td>
              <span class="fw-bold">{{ item.document_number }}</span>
            </td>
  
  
  
            <td>{{ item.description_name }}</td>
  
            <!-- Progress -->
            <td>
              <span class="badge-modern" :class="getProgressBadgeClass(item.progress_status_name)">
                {{ item.progress_status_name }}
              </span>
            </td>
            <td>
              {{ item.renewal_type_name }}
              <span v-if="item.renewal_type_name?.toLowerCase().includes('auto')" class="ms-1"
                title="Auto Renewal"></span>
            </td>
  
            <!-- Status Dokumen -->
            <!-- <td>
                                        <span class="badge-modern" :class="item.status_name === 'ACTIVE' ? 'badge-success' : 'badge-danger'">
                                          {{ item.status_name }}
                                        </span>
                                      </td> -->
  
            <!-- Expired Status -->
            <td>
              <span class="badge-modern" :class="getExpiredBadgeClass(item.expired_status)">
                {{ item.expired_status }}
                <span v-if="item.expired_status !== 'SUPERSEDED'
                                        && item.days_until_expired <= 60
                                        && item.days_until_expired > 0" class="ms-1">
                  (H-{{ item.days_until_expired }})
                </span>
              </span>
            </td>
  
            <!-- ACTION -->
            <td class="text-center">
              <button class="btn-icon-hover icon-warning" @click="goToEdit(item.document_id)"
                :disabled="isEditLocked(item)" :title="isEditLocked(item) ? editLockTitle(item) : 'Edit'">
                <i class="bi bi-pencil"></i>
              </button>
  
              <button class="btn-icon-hover icon-primary" @click="goToDetail(item.document_id)" title="Detail">
                <i class="bi bi-eye"></i>
              </button>
  
              <button class="btn-icon-hover" :class="evaluationIconClass(item)"
                :disabled="isEvaluationButtonDisabled(item)" :title="evaluationTooltip(item)"
                @click="goToEvaluation(item)">
                <i :class="evaluationIcon(item)"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- PAGINATION -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">
        Menampilkan {{ total === 0 ? 0 : (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total
        }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px;" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="changePage(page - 1)">‹</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && changePage(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="changePage(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  
  </div>
</template>

<script>
import MonitoringViewJs from "./MonitoringView";
export default MonitoringViewJs;
</script>